export const PAGES = {
  FORM: "FORM",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
};

export const AUTHORITY_OPTIONS = {
  INFO_ONLY: "INFO_ONLY",
  FULL: "FULL",
  NEITHER: "NEITHER",
};
